import React, { PureComponent } from 'react';
import { Flex } from '../../common/Flex';
import { ServiceFactory } from 'app/service/ServiceFactory';
import { Button, notification, Space } from 'antd';
import { DatasetReferenceType, SimulationDto, SimulationListRequestDto } from 'app/model/CORE';
import { ModalPanelProps } from '../DashboardModal';
import KeyUtils from '../../../common/util/KeyUtils';
import memoizeOne from 'memoize-one';
import { SINGLE_SELECTION, SingleSelection, SortMode } from 'app/common/table/ManagedTable';
import SimulationTable, { SimulationColumn, StandardSimulationColumn } from '../../table/SimulationTable';
import Utils from '../../../common/util/Utils';
import './SimulationPanel.less';

const SIMULATIONS_COLUMNS: SimulationColumn[] = [
    StandardSimulationColumn.TYPE,
    //    SimulationColumns.ID,
    StandardSimulationColumn.NAME,
    StandardSimulationColumn.DESCRIPTION,
    StandardSimulationColumn.PERIOD,
    StandardSimulationColumn.PUBLISH_TIME,
    StandardSimulationColumn.ENGINE_ID,
    StandardSimulationColumn.REFERENCE,
    StandardSimulationColumn.USER,
    StandardSimulationColumn.ANUID,
];

const INITIAL_STATE: SimulationPanelState = {
    simulations: [],
    selection: undefined,
};

interface SimulationPanelProps extends ModalPanelProps {}

interface SimulationPanelState {
    simulations: Array<SimulationDto>;
    selection: SimulationDto;
}

export class SimulationPanel extends PureComponent<SimulationPanelProps, SimulationPanelState> {
    state = INITIAL_STATE;
    public static INITIAL_WIDTH = '100em';
    selection = memoizeOne(
        (selectedSimulation: SimulationDto): SingleSelection<SimulationDto> => ({
            selectionMode: SINGLE_SELECTION,
            onSelectionChange: this.handleSelectionChange,
            selectedItem: selectedSimulation,
        }),
    );

    componentDidMount(): void {
        this.refresh();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.setState(INITIAL_STATE, () => this.refresh());
        }
    }
    refresh = () => {
        const req: SimulationListRequestDto = {
            datasetReference: { type: DatasetReferenceType.OPERATIONAL },
        };
        ServiceFactory.coreService()
            .querySimulations(req)
            .then(reply => {
                if (reply?.error) {
                    notification.error({ message: 'Error', description: reply?.error.message, duration: 0 });
                } else {
                    this.setState({ simulations: reply.data });
                }
            })
            .catch(reason => {
                notification.error({ message: 'Error', description: reason.message, duration: 0 });
            });
    };

    handleSelectionChange = (selection: SimulationDto) => {
        this.setState({ selection: selection });
    };

    handleStopSimulation = () => {
        ServiceFactory.coreService()
            .stopSimulation(this.state.selection.dataset)
            .then(reply => {
                if (reply?.data) {
                    const updatedSimulations = this.state.simulations.slice();
                    updatedSimulations.splice(this.state.simulations.indexOf(this.state.selection));
                    this.setState({ simulations: updatedSimulations }, () =>
                        notification.success({ message: 'Success', description: 'Simulation has been stopped' }),
                    );
                } else {
                    notification.error({ message: 'Error', description: reply?.error?.message, duration: 0 });
                }
            })
            .catch(reason => {
                notification.error({ message: 'Error', description: reason.message, duration: 0 });
            });
    };

    render() {
        return (
            <Flex direction="vertical" className="simulation-panel overflow">
                <Flex className="modal-title header" grow={false} shrink={false}>
                    <Flex direction="vertical">
                        <Flex className="title">ACTIVE SIMULATIONS</Flex>
                        <Flex style={{ justifyContent: 'center' }}>{/*TODO*/}</Flex>
                    </Flex>
                </Flex>
                <Flex className="table">
                    <SimulationTable
                        data={this.state.simulations}
                        columns={SIMULATIONS_COLUMNS}
                        keyProvider={KeyUtils.SIMULATION_KEY_PROVIDER}
                        columnResizeDisabled={true}
                        noDataMessage={'No slots'}
                        selection={this.selection(this.state.selection)}
                        sortMode={SortMode.NONE}
                    />
                </Flex>
                <Flex className="button-panel" grow={false} shrink={false}>
                    <SimulationButtonPanel
                        onClose={this.props.onClose}
                        onRefresh={this.refresh}
                        stopSimulationEnabled={Utils.isExists(this.state.selection)}
                        onStopSimulation={this.handleStopSimulation}
                    />
                </Flex>
            </Flex>
        );
    }
}

interface SimulationButtonPanelProps {
    onClose?(): void;
    onRefresh?(): void;
    stopSimulationEnabled?: boolean;
    onStopSimulation?(): void;
}

class SimulationButtonPanel extends PureComponent<SimulationButtonPanelProps> {
    handleCloseClick = () => {
        this.props.onClose?.();
    };
    handleRefreshClick = () => {
        this.props.onRefresh?.();
    };
    render() {
        return (
            <Space>
                <Button key="close" onClick={this.handleCloseClick}>
                    Close
                </Button>
                <Button key="refresh" onClick={this.handleRefreshClick}>
                    Refresh
                </Button>
                <Button
                    key="stop-simulation"
                    disabled={!this.props.stopSimulationEnabled}
                    onClick={this.props?.onStopSimulation}>
                    Stop simulation
                </Button>
            </Space>
        );
    }
}
